import PricingAndVATProps from "./PricingAndVAT.type";
import React from "react";

import PricingAndVATDesktop from "./PricingAndVATDesktop";
import PricingAndVATMobile from "./PricingAndVATMobile";
import PricingAndVATTablet from "./PricingAndVATTablet";

const removeSpaces = (price: string) => price?.replace(/\s/g, "");

export const formatPrice = (price: number): string => {
  return "£" + price?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

const PricingAndVAT = ({
  saleChannel,
  saleChannelTags,
  buyNowPrice,
  capClean,
  vatType,
  currentBid,
  hpi,
  HPISpecCheckLink,
  vehicleAnalytics,
}) => {
  return (
    <Wrapper
      saleChannel={saleChannel}
      saleChannelTags={saleChannelTags}
      buyNowPrice={buyNowPrice}
      capClean={capClean}
      vatType={vatType}
      currentBid={currentBid}
      hpi={hpi}
      HPISpecCheckLink={HPISpecCheckLink}
      vehicleAnalytics={vehicleAnalytics}
    />
  );
};

const Wrapper: React.FunctionComponent<PricingAndVATProps> = ({
  saleChannel,
  saleChannelTags,
  buyNowPrice,
  capClean,
  vatType,
  currentBid,
  hpi,
  HPISpecCheckLink,
  vehicleAnalytics,
}) => {
  return (
    <>
      <PricingAndVATDesktop
        saleChannel={saleChannel}
        saleChannelTags={saleChannelTags}
        buyNowPrice={removeSpaces(buyNowPrice)}
        capClean={removeSpaces(capClean)}
        vatType={vatType}
        currentBid={currentBid}
        hpi={hpi}
        HPISpecCheckLink={HPISpecCheckLink}
        vehicleAnalytics={vehicleAnalytics}
      />
      <PricingAndVATTablet
        saleChannel={saleChannel}
        buyNowPrice={removeSpaces(buyNowPrice)}
        capClean={removeSpaces(capClean)}
        vatType={vatType}
        currentBid={currentBid}
        hpi={hpi}
        HPISpecCheckLink={HPISpecCheckLink}
        vehicleAnalytics={vehicleAnalytics}
      />
      <PricingAndVATMobile
        saleChannel={saleChannel}
        buyNowPrice={removeSpaces(buyNowPrice)}
        capClean={removeSpaces(capClean)}
        vatType={vatType}
        currentBid={currentBid}
        hpi={hpi}
        HPISpecCheckLink={HPISpecCheckLink}
        vehicleAnalytics={vehicleAnalytics}
      />
    </>
  );
};

export default PricingAndVAT;
